import React from 'react'
import {
  Alert,
  AlertTitle,
  Button,
  Box,
  Typography,
  Paper,
} from '@mui/material'
import { Refresh } from '@mui/icons-material'

const ErrorAlert = ({ 
  message = 'An error occurred', 
  error, 
  onRetry,
  variant = 'filled',
  severity = 'error'
}) => {
  const errorMessage = error?.response?.data?.detail || error?.message || 'Unknown error'

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={2} sx={{ p: 3 }}>
        <Alert severity={severity} variant={variant}>
          <AlertTitle>{message}</AlertTitle>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {errorMessage}
          </Typography>
          {onRetry && (
            <Button
              startIcon={<Refresh />}
              onClick={onRetry}
              size="small"
              variant="outlined"
              color={severity}
            >
              Try Again
            </Button>
          )}
        </Alert>
      </Paper>
    </Box>
  )
}

export default ErrorAlert